import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import UnidadeOrcamentariaForm from "../../../components/forms/UnidadeOrcamentariaForm.vue";
import { UnidadeOrcamentariaService } from "../../../services/UnidadeOrcamentariaService";

export default {
    name: "CriarUnidadeOrcamentaria",
    components: {
        Breadcrumb,
        UnidadeOrcamentariaForm
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Unidades Orçamentárias',
                disabled: false,
                href: '/gerenciar-unidades-orcamentarias'
            },
            {
                text: 'Cadastro de Unidade Orçamentária',
                disabled: true
            }
        ]
    }),
    methods: {
        async handleSave(formData) {
            try {
                const dataToSend = new FormData();
                dataToSend.append("exercicio", formData.exercicio);
                dataToSend.append("codigo_unidade", formData.codigo_unidade);
                dataToSend.append("nome", formData.nome);
                dataToSend.append("ativo", formData.ativo ? 1 : 0);

                const response = await UnidadeOrcamentariaService.store(dataToSend);
                if (response) {
                    this.$router.push('/gerenciar-unidades-orcamentarias');
                } else {
                    throw new Error('Erro ao criar unidade orçamentária');
                }
            } catch (error) {
                console.error('Erro ao criar unidade orçamentária:', error);
                this.$globalAlert('Erro ao criar Unidade Orçamentária');
            }
        },
        handleCancel() {
            this.$router.push('/gerenciar-unidades-orcamentarias');
        }
    }
};
